import React, { useContext, useState } from "react";
import ProfileHeader from "../../profile/components/ProfileHeader";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ProfileContext } from "../../../context/ProfileContext";
import { errorUI, successUI } from "../../../styled/Swal";
import { SupportTicketCreateAPI } from "../api/SupportTicketAPI";
import { ArrowLeft } from "lucide-react";

const ticketObj = {
  title: "",
  description: "",
  date: "",
  time: "",
  requestedBy: "",
  requesterType: "",
  requesterId: "",
  requesterMobile: "",
  requesterEmail: "",
  platform: "Referral Partner",
  ip: "",
  resolutionSummary: {
    resolutionComments: "",
    resolutionDateTime: "",
    status: "",
    resolutionBy: "",
  },
};

function SupportTicketCreate() {
  const { user } = useContext(ProfileContext);
  const { openSidebar } = useOutletContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    ...ticketObj,
    requestedBy: user?.fullName || "",
    requesterId: user?._id || "",
    requesterMobile: user?.mobile || "",
    requesterEmail: user?.email || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // const handleResolutionChange = (e) => {
  //   const { name, value } = e.target;
  //   setForm((prev) => ({
  //     ...prev,
  //     resolutionSummary: { ...prev.resolutionSummary, [name]: value },
  //   }));
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; 

    setIsSubmitting(true);
    try {
      console.log(form);
      const res = await SupportTicketCreateAPI(form);
      if(res.success){
        successUI("Ticket created successfully!");
        setForm({ ...ticketObj, requestedBy: user?.fullName || "", requesterId: user?._id || "", requesterMobile: user?.mobile || "", requesterEmail: user?.email || "" });
      } else {
        errorUI(res?.message);
      }
    } catch (error) {
      errorUI(error?.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="rp-create-leads-page">
      <ProfileHeader onMenuClick={openSidebar} val="Create Support Ticket" />

      <form className="rp-create-leads-form" onSubmit={handleSubmit}>
        <div className="rp-create-leads-actions">
          <button onClick={()=>navigate('/supports')} type="button" className="rp-create-leads-save-btn">
             <ArrowLeft size={16}/> Back
          </button>
          <button disabled={isSubmitting}  type="submit" className="rp-create-leads-save-btn">
            {isSubmitting ? "Saving..." : "Save Ticket"}
          </button>
        </div>
        <div className="rp-create-leads-grid">

          {/* Title */}
          <div className="rp-create-leads-field">
            <label>Title</label>
            <input
              type="text"
              name="title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </div>

          {/* Description */}
         

          {/* Date */}
          <div className="rp-create-leads-field">
            <label>Date</label>
            <input
              type="date"
              name="date"
              value={form.date}
              onChange={handleChange}
              required
            />
          </div>

          {/* Time */}
          <div className="rp-create-leads-field">
            <label>Time</label>
            <input
              type="time"
              name="time"
              value={form.time}
              onChange={handleChange}
              required
            />
          </div>

          {/* Requested By */}
          <div className="rp-create-leads-field">
            <label>Requested By</label>
            <input type="text" value={form.requestedBy} className="rp-personalinfo-input" readOnly disabled />
          </div>

          {/* Mobile */}
          <div className="rp-create-leads-field">
            <label>Mobile</label>
            <input
              type="text"
              name="requesterMobile"
              value={form.requesterMobile}
              onChange={handleChange}
              readOnly disabled
              className="rp-personalinfo-input"
            />
          </div>

          {/* Email */}
          <div className="rp-create-leads-field">
            <label>Email</label>
            <input
              type="email"
              name="requesterEmail"
              value={form.requesterEmail}
              onChange={handleChange}
              readOnly disabled
              className="rp-personalinfo-input"
            />
          </div>

          {/* Platform */}
          <div className="rp-create-leads-field">
            <label>Platform</label>
            <input type="text" value={form.platform} className="rp-personalinfo-input" readOnly disabled />
          </div>

          {/* IP */}
          <div className="rp-create-leads-field">
            <label>IP Address</label>
            <input
              type="text"
              name="ip"
              value={form.ip}
              onChange={handleChange}
            />
          </div>
          
        </div>
         <div style={{marginTop:'20px'}} className="rp-create-leads-field">
            <label>Description</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              required
            />
          </div>

        {/* Resolution Summary */}
        {/* <h3>Resolution Summary</h3>
        <div className="rp-create-leads-grid" style={{ marginTop: "24px" }}>
           
          <div className="rp-create-leads-field">
            <label>Resolution Date & Time</label>
            <input
              type="datetime-local"
              name="resolutionDateTime"
              value={form.resolutionSummary.resolutionDateTime}
              onChange={handleResolutionChange}
            />
          </div>

          <div className="rp-create-leads-field">
            <label>Status</label>
            <select
              name="status"
              value={form.resolutionSummary.status}
              onChange={handleResolutionChange}
            >
              <option value="" disabled>Select Status</option>
              <option value="Pending">Pending</option>
              <option value="Resolved">Resolved</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>

          <div className="rp-create-leads-field">
            <label>Resolved By</label>
            <input
              type="text"
              name="resolutionBy"
              value={form.resolutionSummary.resolutionBy}
              onChange={handleResolutionChange}
            />
          </div>
           
        </div>
        <div style={{marginTop:'20px'}} className="rp-create-leads-field">
            <label>Resolution Comments</label>
            <textarea
              name="resolutionComments"
              value={form.resolutionSummary.resolutionComments}
              onChange={handleResolutionChange}
            />
        </div> */}
        
      </form>
    </div>
  );
}

export default SupportTicketCreate;
